export const SAVE_FORM_VALUES = "SAVE_FORM_VALUES";
export const SAVE_DATA_TABLE = "SAVE_DATA_TABLE";
export const CART_GET_DATA = "CART_GET_DATA";
export const CART_ADD_ITEM = "CART_ADD_ITEM";
export const CART_REMOVE_ITEM = "CART_REMOVE_ITEM";
export const CART_LOAD_ITEMS = "CART_LOAD_ITEMS";
export const CART_TOOGLE_SELECCT_ITEM = "CART_TOOGLE_SELECT_ITEM"